import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";

/* Token-only (no login) review / confirm / preferences / unsubscribe. GET never writes; the CONFIRM button POSTs. */
export default function AlertsManage() {
  const [params] = useSearchParams();
  const confirmTok = params.get("confirm");
  const unsubTok = params.get("unsub");
  const token = params.get("token");
  const [state, setState] = useState({ loading: true });
  const [prefs, setPrefs] = useState({});
  useEffect(() => {
    (async () => {
      try {
        if (unsubTok) { const { data } = await api.get(`/alerts/unsubscribe?token=${unsubTok}`); setState({ done: data.detail }); return; }
        if (confirmTok) { const { data } = await api.get(`/alerts/confirm?token=${confirmTok}`); setState({ review: data.review, needsConfirm: data.requires_explicit_confirmation }); return; }
        if (token) { const { data } = await api.get(`/alerts/manage?token=${token}`); setState({ sub: data.subscription, needsChoice: data.needs_program_choice }); setPrefs(data.subscription || {}); return; }
        setState({ error: "Missing link." });
      } catch (e) { setState({ error: e.response?.data?.detail || "This link is invalid." }); }
    })();
  }, [confirmTok, unsubTok, token]);
  const confirm = async () => {
    try { const { data } = await api.post("/alerts/confirm", { token: confirmTok }); setState({ done: "Weekly alerts confirmed. Tuesdays 10am Central, only when there are new openings.", manage: data.manage_token }); }
    catch (e) { setState({ error: e.response?.data?.detail || "Could not confirm." }); }
  };
  const save = async () => {
    try { await api.post("/alerts/preferences", { token, ...prefs }); setState((s) => ({ ...s, saved: true })); }
    catch (e) { setState((s) => ({ ...s, error: e.response?.data?.detail || "Could not save." })); }
  };
  const unsubscribe = async () => { const { data } = await api.get(`/alerts/unsubscribe?token=${token || state.manage}`); setState({ done: data.detail }); };
  const L = { mens: "Men's", womens: "Women's", both: "Both" };
  return (
    <div className="min-h-screen bg-appbg text-white">
      <Header />
      <div className="px-4 md:px-8 py-12 max-w-xl" data-testid="alerts-manage-page">
        <div className="text-xs tracking-widest text-blaze">WEEKLY JOB ALERTS</div>
        {state.loading && <div className="heading text-2xl mt-3">LOADING…</div>}
        {state.error && <div className="mt-3 text-sm text-red-400" data-testid="alerts-error">{state.error}</div>}
        {state.done && <div className="mt-3 text-sm text-volt" data-testid="alerts-done">{state.done}</div>}
        {state.review && (
          <div className="mt-4 border border-neutral-800 p-5" data-testid="alerts-review">
            <h1 className="heading text-3xl">CONFIRM YOUR ALERTS</h1>
            <p className="text-sm text-neutral-300 mt-2">You'll get one weekly email with new <b>{L[state.review.program_preference] || "Men's & Women's"}</b> lacrosse coaching openings{state.review.level ? ` · ${state.review.level}` : ""}{state.review.state ? ` · ${state.review.state}` : ""}. Nothing is sent until you confirm below.</p>
            {state.needsConfirm ? <button onClick={confirm} data-testid="alerts-confirm-btn" className="mt-4 bg-blaze text-white heading text-sm px-5 py-3">YES, CONFIRM MY WEEKLY ALERTS</button> : <div className="mt-3 text-xs text-volt">Already confirmed.</div>}
          </div>
        )}
        {state.sub && (
          <div className="mt-4 border border-neutral-800 p-5" data-testid="alerts-prefs">
            <h1 className="heading text-3xl">PREFERENCES</h1>
            {state.needsChoice && <div className="mt-2 text-xs text-blaze" data-testid="alerts-needs-choice">Choose Men's, Women's or Both to receive targeted alerts.</div>}
            <div className="mt-3 flex gap-2">{["mens", "womens", "both"].map((v) => <button key={v} data-testid={`prefs-program-${v}`} onClick={() => setPrefs({ ...prefs, program_preference: v })} className={`px-3 py-1.5 text-xs border ${prefs.program_preference === v ? "bg-white text-black border-white" : "border-neutral-700"}`}>{L[v]}</button>)}</div>
            <div className="mt-3 flex gap-2">
              <select value={prefs.frequency || "weekly"} onChange={(e) => setPrefs({ ...prefs, frequency: e.target.value })} data-testid="prefs-frequency" className="bg-appbg border border-neutral-700 px-2 py-2 text-sm"><option value="weekly">Weekly</option><option value="off">Off (keep subscription, no email)</option></select>
              <input placeholder="State" maxLength={2} value={prefs.state || ""} onChange={(e) => setPrefs({ ...prefs, state: e.target.value.toUpperCase() })} data-testid="prefs-state" className="bg-appbg border border-neutral-700 px-2 py-2 text-sm w-24" />
            </div>
            <div className="mt-4 flex gap-3 items-center">
              <button onClick={save} data-testid="prefs-save" className="bg-blaze text-white heading text-sm px-5 py-3">SAVE</button>
              <button onClick={unsubscribe} data-testid="prefs-unsubscribe" className="text-xs text-neutral-400 underline">Unsubscribe from all marketing email</button>
              {state.saved && <span className="text-xs text-volt">Saved.</span>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
